import { useFetchUrlCache } from '../utils/useFetchUrlCache';
import { EnvType } from '../app/types/enum';

let appConfig = {} as IAppConfig;

export const setupAppConfig = async () => {
  appConfig = await useFetchUrlCache('configurations/appConfig.json');
  appConfig.envType = getEnvironmentType();
};

export { appConfig };

const EnvTypeMap = {
  dev01: EnvType.dev,
  dev02: EnvType.dev,
  dev03: EnvType.dev,
  dev04: EnvType.dev,
  dev05: EnvType.dev,
  qa01: EnvType.qa,
  qa02: EnvType.qa,
  qa03: EnvType.qa,
  qa04: EnvType.qa,
  qa05: EnvType.qa,
  qa06: EnvType.qa,
  qa07: EnvType.qa,
  qa08: EnvType.qa,
  qa09: EnvType.qa,
  qa10: EnvType.qa,
  staging01: EnvType.staging,
  staging02: EnvType.staging,
  staging03: EnvType.staging,
  prdc: EnvType.staging,
};

export function getEnvironmentType(): EnvType {
  if (appConfig.apiEnv && EnvTypeMap[appConfig.apiEnv]) {
    return EnvTypeMap[appConfig.apiEnv];
  }
  return EnvType.prod;
}
